import { formatSecondsToMinutesAndSeconds } from '@appvantageasia/core-utils';
import type { TFunction } from 'i18next';
import type { CognitiveFitness, SimpleMetric } from '../../model';
import type { AssessmentResultItemDataFragment } from '@/gql/graphql';

const parseConcentrationGrid = (t: TFunction, items: AssessmentResultItemDataFragment[]): CognitiveFitness | null => {
    const item = items.find(i => i.result.__typename === 'ConcentrationGridResult');
    if (!item || item.result.__typename !== 'ConcentrationGridResult') {
        return null;
    }
    const mi = item.moduleInstance;
    const r = item.result;
    if (!mi?.name) {
        return null;
    }

    const metrics: SimpleMetric[] = [];

    // completion time
    metrics.push({
        label: t('traineeReports:performance.cognitiveFitness.completionTime'),
        value: formatSecondsToMinutesAndSeconds(r.completionTimeSeconds),
    });

    // completion percentage
    metrics.push({
        label: t('traineeReports:performance.cognitiveFitness.completionPercentage'),
        value: r.completion.toFixed(0),
    });

    // accuracy
    metrics.push({
        label: t('traineeReports:performance.cognitiveFitness.accuracy'),
        value: r.accuracy.toFixed(1),
    });

    // average time per number
    metrics.push({
        label: t('traineeReports:performance.cognitiveFitness.avgTimePerNumber'),
        value: t('traineeReports:value.seconds', { value: r.avgTimePerNumberSeconds.toFixed(1) }),
    });

    return {
        name: mi.name,
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        description: mi.description ?? '',
        result: metrics,
    };
};

export default parseConcentrationGrid;
